function hackyGetUqudoStep() {
  // xxx hack get uqudo step
  // refer uqudo class: https://docs.uqudo.com/docs/kyc/uqudo-sdk/integration/web/ui-customisation/styles-configuration
  const selectorMap = {
    '.uq-button.uq-upload-button:not([disabled])':
      'UQUDO_STEP_AFTER_UPLOAD_DOCUMENT',
    '.uq-upload-page': 'UQUDO_STEP_UPLOAD_DOCUMENT',
    '.uqudo-loading-screen-mobile': 'UQUDO_STEP_BEFORE_SCAN_FIRST',
    '.uq-scan-title.uq-hide': 'UQUDO_STEP_SCAN_DONE', // both for captured front and back
    '.uqudo-side-card.uqudo-front-side': 'UQUDO_STEP_SCAN_FIRST',
    '.uq-scan-turn-over-page': 'UQUDO_STEP_BEFORE_SCAN_SECOND',
    '.uqudo-side-card.uqudo-back-side': 'UQUDO_STEP_SCAN_SECOND',
    '.uq-face-page:has(.uq-face-button.uq-hide)': 'UQUDO_STEP_BEFORE_FACE_SCAN', // uq-face-page-title
    '.uq-face-button:not(.uq-hide)': 'UQUDO_STEP_FACE_SCAN',
    '.uq-loading-page': 'UQUDO_LOADING_SCREEN', // for all loading status,
  }
  const key = Object.keys(selectorMap).find((k) => !!document.querySelector(k))
  return key && selectorMap[key]
}
const tamaraAppLink = 'https://apptamara.page.link/kyc-onboarding'

export { hackyGetUqudoStep, tamaraAppLink }
